'use client';

import { LazyLottie } from './LazyLottie';
import { IAnimationProps } from './types';

export function AssessmentBlackToWhiteAnimation(props: IAnimationProps) {
  const loadAnimation = () =>
    import('./raw-json/assessment-black-to-white-swipe-animation.json');

  return (
    <LazyLottie
      {...props}
      getAnimationData={loadAnimation}
      id="AssessmentBlackToWhiteAnimation"
    />
  );
}
